import { render, staticRenderFns } from "./VisualizarEnderecos.vue?vue&type=template&id=d28f1c82&"
import script from "./VisualizarEnderecos.vue?vue&type=script&lang=js&"
export * from "./VisualizarEnderecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports